import { render, staticRenderFns } from "./TaskWidget.vue?vue&type=template&id=1901ff5c&"
import script from "./TaskWidget.vue?vue&type=script&lang=js&"
export * from "./TaskWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaskWidget.vue"
export default component.exports